module.exports = __webpack_public_path__ + "img/user.01257da0.png";